$(function() {

  document.addEventListener('scroll', scroll);
  var videos = document.querySelectorAll('video');

  window.onload = function() {
    onVideoEnd()
  }

  function scroll() {
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    videos.forEach(element => {
      var item = element.getBoundingClientRect();

      if ( item.top - 350 <= 0 &&  item.top + item.height >= 0 ) {
        element.play();
      } else {
        element.currentTime = 0;
      }
    });
  }

  function onVideoEnd() {
    videos.forEach(element => {
      element.addEventListener('ended', function(){
        var splashScreen =  element.closest('.emulator').querySelector('.splash-screen');
        element.classList.remove('fadeIn');
        splashScreen.classList.remove('fadeOut');
        element.classList.add('fadeOut');
        splashScreen.classList.add('fadeIn');

        setTimeout(function(){
          splashScreen.classList.remove('fadeIn');
          splashScreen.classList.add('fadeOut');
          element.classList.remove('fadeOut');
          element.classList.add('fadeIn');
          element.play();
        }, 3000);
      });
    });
  }

});


// WEBPACK FOOTER //
// ./app/assets/js/videoPlayScroll.js